import { executeOnce } from '../../../utils'

import { FetchConnectwareHTTPService } from '../Base'

export abstract class ConnectwareHTTPCapabilitiesService extends FetchConnectwareHTTPService {
    protected readonly fetchEntraStatus = executeOnce(() =>
        this.request<'/api/auth/msEntraId', 'GET', boolean>({
            /**
             * This endpoint does not require authentication
             */
            capability: null,
            method: 'GET',
            path: '/api/auth/msEntraId',
            handlers: { 200: (response) => response.getJson().then((r) => r.enabled) },
        })
    )
}
